import formValidator from "./js/_scripts";
export default formValidator;

formValidator.init();
